import React, { useState } from 'react';
import { FaHome, FaUser, FaBars, FaTimes, FaLaptopCode, FaBriefcase, FaCode} from 'react-icons/fa';
import { HiOutlineEnvelope } from 'react-icons/hi2';
import './header.scss';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const section = document.getElementById(target);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <header className="header-container">
      <a href="#home" className="logo" onClick={(e) => handleClick(e, 'home')}>
        CARMELLA SETIABUDI
      </a>
      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <FaTimes size={30} className="close-icon" /> : <FaBars size={30} />}
      </div>
      <nav className={`nav ${isOpen ? 'open' : ''}`}>
        <a href="#home" className="nav-link" onClick={(e) => handleClick(e, 'home')}>
          <FaHome />
          Home
        </a>
        <a href="#about" className="nav-link" onClick={(e) => handleClick(e, 'about')}>
          <FaUser />
          About
        </a>
        <a href="#resume" className="nav-link" onClick={(e) => handleClick(e, 'resume')}>
          <FaBriefcase />
          Experience
        </a>
        <a href="#projects" className="nav-link" onClick={(e) => handleClick(e, 'projects')}>
          <FaLaptopCode />
          Projects
        </a>
        
        <a href="#skills" className="nav-link" onClick={(e) => handleClick(e, 'skills')}>
          <FaCode />
          Skills
        </a>
        <a href="#connect" className="nav-link" onClick={(e) => handleClick(e, 'connect')}>
          <HiOutlineEnvelope />
          Contact
        </a>
        
      </nav>
    </header>
  );
};

export default Header;
